module.exports = __webpack_public_path__ + "img/safetyImg6.669a7105.png";